import { Component } from "react";
import VerificationCodeLayout from "./VerificationCodeLayout";
import { resolveVerificationCodeInput } from "components/functions/VerificationCodeResolver";
import FetcherApi from "components/components/FetcherApi";
import urlTools from "components/tools/urlTools";
import ErrorMessagesService from "components/services/ErrorMessagesService";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import EmailAndPhoneValidator from "components/components/EmailAndPhoneValidator";

class VerificationCode extends Component {
	state = {
		activationCode: { code1: "0", code2: "0", code3: "0", code4: "0" },
		error: null,
		isResendSuccessDisplayed: false,
		isConfirmDisabled: false,
		hasAttempted: false,
		hideCodeEntryControls: false,
		codeAttemptsLeft: null
	}

	onChange = e => {
		const { activationCode } = this.state;

		activationCode[e.prop] = resolveVerificationCodeInput(e);
		this.setState({ activationCode, error: null });
	};

	onResend = async _ => {
		const result = (await FetcherApi.post(urlTools.constructRoute(this.props.resendUrl))).response;

		this.setState({
			isResendSuccessDisplayed: result.data.success,
			error: !result.data.success ? "enter_existing_card_page_rate_limit_reached" : null
		});
	};

	onResendSuccessDisplayExpiration = () => {
		this.setState({ isResendSuccessDisplayed: false });
	};

	onConfirm = async _ => {
		this.setState({ isConfirmDisabled: true });

		const { activationCode } = this.state;
		const result = (await FetcherApi.post(urlTools.constructRoute(this.props.confirmUrl), {
			code: activationCode.code1 + activationCode.code2 + activationCode.code3 + activationCode.code4
		})).response;


		if (result.data.success) {
			const redirectPath = this.props.getSuccessSpaRoute(result.data.resultObject);
			this.props.history.push({
				pathname: redirectPath,
				search: window.location.search,
				state: {
					verificationCodePassed: true,
					codeSentTo: this.props.location.state.codeSentTo,
					...(this.props.location.state.nextStepState || {})
				}
			});

			return;
		}

		const parsedErrorResponse = ErrorMessagesService.parseVerificationCodeErrorResponse(result.data.resultObject);
		this.setState({
			isConfirmDisabled: false,
			hasAttempted: true,
			activationCode: { code1: "0", code2: "0", code3: "0", code4: "0" },
			codeAttemptsLeft: parsedErrorResponse.codeAttemptsLeft,
			hideCodeEntryControls: parsedErrorResponse.hideCodeEntryControls,
			error: parsedErrorResponse.errorMessage
				? parsedErrorResponse.errorMessage
				: ErrorMessagesService.getConvertedVerificationCodeError(result.data.error)
		});
	};

	render() {
		const isEmail = EmailAndPhoneValidator.IsEmailStructureValid(this.props.location.state.codeSentTo);
		return (
			<VerificationCodeLayout
				initialData={this.props.initialData}
				previousPath={this.props.location.state.previousPath}
				previousState={this.props.location.state.previousState}

				header={this.props.header}
				secondaryButtonText={this.props.secondaryButtonText}
				secondaryButtonLinkTo={this.props.secondaryButtonLinkTo}
				onSecondaryButtonClick={this.props.onSecondaryButtonClick}
				resendText={isEmail ? "verification_code_page_resend_text_email" : "verification_code_page_resend_text_phone"}
				infoText={isEmail ? "verification_code_page_info_text_email" : "verification_code_page_info_text_phone"}
				infoTextValues={{ sentTo: this.props.location.state.codeSentTo }}

				error={this.state.error}
				hasAttempted={this.state.hasAttempted}
				activationCode={this.state.activationCode}
				codeAttemptsLeft={this.state.codeAttemptsLeft}
				isConfirmDisabled={this.state.isConfirmDisabled}
				hideCodeEntryControls={this.state.hideCodeEntryControls}
				isResendSuccessDisplayed={this.state.isResendSuccessDisplayed}

				onChange={this.onChange}
				onResend={this.onResend}
				onConfirm={this.onConfirm}
				onResendSuccessDisplayExpiration={this.onResendSuccessDisplayExpiration}
			/>
		);
	}
}

export default withRouter(VerificationCode);